import { render, staticRenderFns } from "./ModuleSchemeSlots.vue?vue&type=template&id=a1e63bfa&scoped=true"
import script from "./ModuleSchemeSlots.vue?vue&type=script&lang=js"
export * from "./ModuleSchemeSlots.vue?vue&type=script&lang=js"
import style0 from "./ModuleSchemeSlots.vue?vue&type=style&index=0&id=a1e63bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e63bfa",
  null
  
)

export default component.exports